import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { TrendingUp, TrendingDown, Home } from "lucide-react";

const fmtBRL = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(n || 0);
const fmtDec = (n, d = 2) => new Intl.NumberFormat("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d }).format(n || 0);

export default function RadarFipeZap() {
  const [data, setData] = useState(null);
  const [city, setCity] = useState("");

  const load = () => clientApi.get("/fipezap", { params: { city: city || undefined } }).then(({ data }) => setData(data)).catch(() => setData(null));
  useEffect(() => { load(); }, []);
  const d = data?.data;

  return (
    <div className="space-y-6" data-testid="cliente-fipezap-page">
      <div className="flex flex-wrap justify-between items-end gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Radar de Mercado</div>
          <h1 className="font-display text-3xl md:text-4xl">FipeZap · Índice de Preços {data?.source === "demo" && <span className="text-xs text-neutral-500 lowercase tracking-widest">(demo)</span>}</h1>
          <p className="text-sm text-neutral-400 mt-2">Índice consolidado de preços do mercado imobiliário nacional.</p>
        </div>
        <div className="flex gap-2 items-end">
          <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Goiânia/GO" className="bg-black border border-white/10 rounded-lg px-3 py-2 text-sm" />
          <button onClick={load} className="bg-accent-orange text-white text-xs font-bold px-4 py-2.5 rounded-full">Consultar</button>
        </div>
      </div>

      {d && (
        <>
          <div className="grid md:grid-cols-4 gap-4">
            <Metric label="Índice atual" value={fmtDec(d.index_current, 1)} />
            <Metric label="Var. mensal" value={`${d.variation_month > 0 ? "+" : ""}${fmtDec(d.variation_month, 2)}%`} up={d.variation_month >= 0} />
            <Metric label="Var. 12 meses" value={`${d.variation_12m > 0 ? "+" : ""}${fmtDec(d.variation_12m, 1)}%`} up={d.variation_12m >= 0} />
            <Metric label="Var. 5 anos" value={`${d.variation_5y > 0 ? "+" : ""}${fmtDec(d.variation_5y, 1)}%`} up={d.variation_5y >= 0} />
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
              <div className="text-xs uppercase tracking-widest text-accent-orange mb-2">Preço médio m² · Venda</div>
              <div className="font-display text-4xl">{fmtBRL(d.avg_price_sqm_venda)}</div>
            </div>
            <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
              <div className="text-xs uppercase tracking-widest text-accent-orange mb-2">Preço médio m² · Aluguel</div>
              <div className="font-display text-4xl">{fmtBRL(d.avg_price_sqm_aluguel)}</div>
            </div>
          </div>

          {d.top_neighborhoods && (
            <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
              <div className="text-xs uppercase tracking-widest text-accent-orange mb-4">Bairros com maior preço</div>
              <div className="space-y-2">
                {d.top_neighborhoods.map((n, i) => (
                  <div key={i} className="flex justify-between items-center border-b border-white/5 pb-2 last:border-0">
                    <div className="flex items-center gap-3">
                      <Home className="w-4 h-4 text-accent-orange" />
                      <span className="font-semibold">{n.name}</span>
                    </div>
                    <div className="flex items-center gap-4 text-sm">
                      <span className="text-neutral-400">{fmtBRL(n.sqm)}/m²</span>
                      <span className={n.variation >= 0 ? "text-green-400" : "text-red-400"}>
                        {n.variation >= 0 ? "+" : ""}{fmtDec(n.variation, 1)}%
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      <div className="text-[11px] text-neutral-500 text-center border-t border-white/5 pt-4">
        Integração <b>FipeZap</b> · dados atualizados mensalmente.
      </div>
    </div>
  );
}

function Metric({ label, value, up }) {
  return (
    <div className="border border-white/10 rounded-xl p-5 bg-white/[0.02]">
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">{label}</div>
      <div className={`font-display text-3xl flex items-center gap-2 ${up === true ? "text-green-400" : up === false ? "text-red-400" : ""}`}>
        {value}
        {up === true && <TrendingUp className="w-5 h-5" />}
        {up === false && <TrendingDown className="w-5 h-5" />}
      </div>
    </div>
  );
}
